import React from "react";
import { Item } from "../../data/ItemOfBusiness";

export interface VoteDisplayProps {
  item: Item | null;
}

function VoteDisplay({ item }: VoteDisplayProps) {
  if (item == null || item.votes === 0 || item.voteCounts == null) {
    return <></>;
  }

  // Bishops vote within the Clergy house; their separate row is not shown
  const counts = item.voteCounts.filter((count) => count.house !== "Bishops");

  return (
    <div className="table-responsive-md">
      <table className="table" style={{ maxWidth: "450px" }}>
        <thead>
          <tr>
            <th>House</th>
            <th className="text-end">Total</th>
            <th className="text-end">For</th>
            <th className="text-end">Against</th>
            <th className="text-end">Abstain</th>
          </tr>
        </thead>
        <tbody>
          {counts.map((count) => (
            <tr key={`${item.subId}.${count.house}`} className={count.house === "Total" ? "table-light fw-bold" : ""}>
              <td>{count.house}</td>
              <td className="text-end sl-num">{count.total}</td>
              <td className="text-end sl-num">{count.votesFor}</td>
              <td className="text-end sl-num">{count.votesAgainst}</td>
              <td className="text-end sl-num">{count.votesAbstain}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default VoteDisplay;
